import { render, staticRenderFns } from "./ExemptionExams.vue?vue&type=template&id=2d2f4747&"
import script from "./ExemptionExams.vue?vue&type=script&lang=js&"
export * from "./ExemptionExams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports